import {
  isCreditLensFeatureEnabled,
  isDbsJwtLoginEnabled
} from "src/configState/selector";
import { State } from "src/state";
import actionCreatorFactory from "typescript-fsa";
import { asyncFactory, thunkToAction } from "typescript-fsa-redux-thunk";
import api from "../api";
import { transformRawMetadataConfigIntoFrontEndConfig } from "./helpers";
import {
  MetadataFrontEndConfig,
  MetadataPayload,
  UpdateMetadataConfigPayload
} from "./types";

const create = actionCreatorFactory("Metadata");

const createAsync = asyncFactory<State>(create);

interface GetClientMetadataSuccessParams {
  spreadId: string;
}

export const getMetadataConfig = createAsync<
  GetClientMetadataSuccessParams,
  MetadataFrontEndConfig
>("GET_METADATA_CONFIG", async (params, dispatch, getState) => {
  const { spreadId } = params;
  const isCreditLens = isCreditLensFeatureEnabled(getState());
  const isDbs = isDbsJwtLoginEnabled(getState());
  const metadataConfig = await api.metadata.getWorkspaceConfig(
    isCreditLens,
    spreadId
  );
  const metadataFrontendConfig = transformRawMetadataConfigIntoFrontEndConfig(
    metadataConfig,
    isDbs
  );
  return metadataFrontendConfig;
});

const getMetadataConfigAction = thunkToAction(getMetadataConfig.action);
export type GetMetadataConfigActionType = typeof getMetadataConfigAction;

interface UpdateSpreadMetadataSuccessParams {
  version: number;
  metadata: MetadataPayload;
}

export const updateSpreadMetadata = createAsync<
  UpdateMetadataConfigPayload,
  UpdateSpreadMetadataSuccessParams
>("UPDATE_SPREAD_METADATA", async (params, dispatch, getState) => {
  const { version } = await api.metadata.updateConfigForSpread(
    params,
    isCreditLensFeatureEnabled(getState())
  );

  const { userId, spreadId, spreadVersion, ...metadata } = params;
  return { version, metadata };
});

const updateSpreadMetadataAction = thunkToAction(updateSpreadMetadata.action);
export type UpdateSpreadMetadataType = typeof updateSpreadMetadataAction;



// WEBPACK FOOTER //
// ./src/metadata/actions.ts